module.exports = __webpack_public_path__ + "img/banner1.80d19c61.png";